window.LimiteCreditoView = Backbone.Marionette.CompositeView.extend({
    template: "#template-listar-limite-credito",

    initialize: function(options) {
        this.app = options.app,
            this.model = options.model;
    }
});